'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = isAvailabilityObject;
function isAvailabilityObject(obj) {
    if (!obj) return true;

    var keys = Object.keys(obj);

    return keys.indexOf('weekly') !== -1 || keys.indexOf('exceptions') !== -1 || Object.keys(obj).length === 0 && typeof obj !== 'function';
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/availability/dist/utils/isAvailabilityObject.js
// module id = 882
// module chunks = 0